module.exports = __webpack_public_path__ + "img/phono.af218f4a.png";